import { IUser, Maybe } from 'types/graphqlTypes'
import { TAutocompleteValueSchema } from '../schema/AutocompleteValueSchema'

export const getDefaultAutocompleteTransfixUserValue = (
  applicationRelationship: Maybe<{
    user: Pick<IUser, 'id' | 'fullName'>
  }>
): TAutocompleteValueSchema | null => {
  const { user } = applicationRelationship ?? {}

  if (!user) {
    return null
  }

  return {
    id: user.id,
    text: user.fullName ?? '',
  }
}
